/**
 * Search results page — tabs count fetch + sort dropdown (no Section Rendering).
 */
(function () {
  'use strict';

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function qsa(root, sel) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }

  function setSortExpanded(trigger, menu, expanded) {
    if (!trigger || !menu) return;
    menu.hidden = !expanded;
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var down = qs(trigger, '[data-ts-sort-chevron-down]');
    var up = qs(trigger, '[data-ts-sort-chevron-up]');
    if (down) down.hidden = !!expanded;
    if (up) up.hidden = !expanded;
  }

  function closeOpenSortMenus() {
    qsa(document, '[data-ts-sort-menu]:not([hidden])').forEach(function (menu) {
      var wrap = menu.closest('[data-ts-sort-wrap]');
      var trigger = wrap && qs(wrap, '[data-ts-sort-trigger]');
      setSortExpanded(trigger, menu, false);
    });
  }

  function fetchTabCount(terms, type) {
    var url = new URL('/search', window.location.origin);
    url.searchParams.set('q', terms);
    url.searchParams.set('type', type);
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('view', 'tab-count');
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('tab-count failed');
        return res.text();
      })
      .then(function (text) {
        var n = parseInt(String(text).trim(), 10);
        return isNaN(n) ? 0 : n;
      })
      .catch(function () {
        return null;
      });
  }

  function SearchPage(root) {
    this.root = root;
    this.terms = root.getAttribute('data-search-terms') || '';
    this.currentType = root.getAttribute('data-search-type') || 'product';
    this.isEmpty = root.getAttribute('data-search-empty') === 'true';

    /* Default landing to Products tab for correct pagination */
    var url = new URL(window.location.href);
    if (this.terms && !url.searchParams.get('type')) {
      url.searchParams.set('type', 'product');
      window.location.replace(url.pathname + url.search + url.hash);
      return;
    }

    this.bindSort();
    this.loadTabCounts();
  }

  SearchPage.prototype.bindSort = function () {
    var self = this;
    var wrap = qs(this.root, '[data-ts-sort-wrap]');
    if (!wrap || wrap.dataset.tsSortMenuBound === 'true') return;
    wrap.dataset.tsSortMenuBound = 'true';

    var select = qs(wrap, '[data-ts-sort]');
    var trigger = qs(wrap, '[data-ts-sort-trigger]');
    var menu = qs(wrap, '[data-ts-sort-menu]');
    if (!select || !trigger || !menu) return;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setSortExpanded(trigger, menu, menu.hidden);
    });

    menu.addEventListener('click', function (event) {
      var option = event.target && event.target.closest && event.target.closest('[role="option"]');
      if (!option || !menu.contains(option)) return;
      event.preventDefault();

      var value = option.getAttribute('data-value');
      if (value == null) return;

      select.value = value;
      qsa(menu, '[role="option"]').forEach(function (el) {
        el.setAttribute('aria-selected', el === option ? 'true' : 'false');
      });
      var label = qs(wrap, '[data-ts-sort-label]');
      if (label) label.textContent = option.textContent.trim();
      setSortExpanded(trigger, menu, false);

      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      if (!url.searchParams.get('type')) {
        url.searchParams.set('type', self.currentType || 'product');
      }
      window.location.assign(url.pathname + url.search);
    });
  };

  SearchPage.prototype.loadTabCounts = function () {
    var self = this;
    if (!this.terms) return;

    var types = ['product', 'article', 'page'];
    var promises = types.map(function (type) {
      if (type === self.currentType && self.root.getAttribute('data-search-empty') !== 'true') {
        /* Active tab already has count from Liquid when type is explicit;
           still refresh when implicit (—). */
      }
      return fetchTabCount(self.terms, type).then(function (count) {
        return { type: type, count: count };
      });
    });

    Promise.all(promises).then(function (rows) {
      var otherTotal = 0;
      rows.forEach(function (row) {
        if (row.count == null) return;
        var el = qs(self.root, '[data-ts-tab-count="' + row.type + '"]');
        if (el) el.textContent = '(' + row.count + ')';
        if (row.type !== self.currentType) {
          otherTotal += row.count;
        }
      });

      /* Hide empty-search extras if other tabs still have hits */
      if (self.isEmpty && otherTotal > 0) {
        qsa(document, '[data-ts-search-empty-extra]').forEach(function (el) {
          el.hidden = true;
          var section = el.closest('.shopify-section');
          if (section) section.hidden = true;
        });
        var emptyCard = qs(self.root, '[data-ts-search-empty]');
        if (emptyCard) emptyCard.hidden = true;
      }
    });
  };

  function init() {
    var root = document.querySelector('[data-ts-search-page]');
    if (!root || root.dataset.tsSearchBound === 'true') return;
    root.dataset.tsSearchBound = 'true';
    new SearchPage(root);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-ts-sort-wrap]')) return;
    closeOpenSortMenus();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
